<nz-tag
  nzColor="warning"
  *ngIf="showTag$ | ngrxPush">
  <i
    nz-icon
    nzType="exclamation-circle"></i>
  <span>End of results reached</span>
</nz-tag>
